import { useField } from "formik";

const SelectInput = ({ label, data, labelClassName, ...props }) => {
  const [field, meta] = useField(props);
  const isError = meta.touched && meta.error;
  const handleChange = (e) => {
    field.onChange(e); // This handles Formik's state update
    if (props.onChange) {
      props.onChange(e); // This calls any custom onChange passed from parent
    }
  };
  

  return (
    <div className="flex flex-col">
      <label
        className={`p-1 text-gray-700 flex gap-1 ${labelClassName || 'text-lg'}`}
        htmlFor={props.id || props.name}
      >
        {label}
        {meta.touched && meta.error ? (
        <div className="text-red-500 text-[12px]">*</div>
      ) : null} 
      </label>
      <select
        className={`${isError
            ? "p-2 rounded-lg border border-red-700 shadow-lg outline-none"
            : "p-2 rounded-lg border border-gray-500 shadow-lg outline-none"
          }`}
        {...field}
        {...props}
        onChange={handleChange}
      ></select>
      {/* {meta.touched && meta.error ? (
        <div className="text-red-500 text-[12px]">{meta.error}</div>
      ) : null} */}
    </div>
  );
};

export default SelectInput;
